import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import {
  Client,
  ClientCreate,
  ClientGet,
  ClientRateLimit,
  RequestClientsDatatable,
} from '../_models/clients.models';
import { Datatable } from '../_models/report.models';
import { Error } from '../_models/auth.models';
export enum ClientsActionTypes {
  LOAD_CLIENTS = '[Clients] Load',
  LOAD_CLIENTS_SUCCESS = '[Clients] Load Success',
  LOAD_CLIENTS_FAILED = '[Clients] Load Failed',
  LOAD_DATATABLE = '[Clients] Load Datatable',
  LOAD_DATATABLE_SUCCESS = '[Clients] Load Datatable Success',
  LOAD_DATATABLE_FAILED = '[Clients] Load Datatable Failed',
  GET_CLIENT = '[Clients] Get Client',
  GET_CLIENT_SUCCESS = '[Clients] Get Client Success',
  GET_CLIENT_FAILED = '[Clients] Get Client Failed',
  UPDATE_CLIENT = '[Clients] Update Client',
  UPDATE_CLIENT_SUCCESS = '[Clients] Update Client Success',
  UPDATE_CLIENT_FAILED = '[Clients] Update Client Failed',
  DELETE_CLIENT = '[Clients] Delete Client',
  DELETE_CLIENT_SUCCESS = '[Clients] Delete Client Success',
  DELETE_CLIENT_FAILED = '[Clients] Delete Client Failed',
  CREATE_CLIENT = '[Clients] Create Client',
  CREATE_CLIENT_SUCCESS = '[Clients] Create Client Success',
  CREATE_CLIENT_FAILED = '[Clients] Create Client Failed',
  UPDATE_CLIENT_THROTTLE = '[Clients] Update Client Throttle',
  UPDATE_CLIENT_THROTTLE_SUCCESS = '[Clients] Update Client Throttle Success',
  UPDATE_CLIENT_THROTTLE_FAILED = '[Clients] Update Client Throttle Failed',
  BULK_UPDATE_CLIENTS = '[Clients] Bulk Update Clients',
  BULK_UPDATE_CLIENTS_SUCCESS = '[Clients] Bulk Update Clients Success',
  BULK_UPDATE_CLIENTS_FAILED = '[Clients] Bulk Update Clients Failed',
  RESET = '[Clients] RESET',
}
export class LoadClients implements Action {
  readonly type = ClientsActionTypes.LOAD_CLIENTS;

  constructor() {}
}

export class LoadClientsSucces implements Action {
  readonly type = ClientsActionTypes.LOAD_CLIENTS_SUCCESS;

  constructor(public payload: Array<Client>) {}
}

export class LoadClientsFailed implements Action {
  readonly type = ClientsActionTypes.LOAD_CLIENTS_FAILED;

  constructor(public payload: Error) {}
}

export class GetClient implements Action {
  readonly type = ClientsActionTypes.GET_CLIENT;

  constructor(public clientId: any) {}
}

export class GetClientSuccess implements Action {
  readonly type = ClientsActionTypes.GET_CLIENT_SUCCESS;

  constructor(public clientId: string, public payload: any) {}
}

export class GetClientFailed implements Action {
  readonly type = ClientsActionTypes.GET_CLIENT_FAILED;

  constructor(public payload: Error) {}
}

export class CreateClient extends Reference implements Action {
  readonly type = ClientsActionTypes.CREATE_CLIENT;

  constructor(public payload: ClientCreate) {
    super();
  }
}

export class CreateClientSuccess extends Reference implements Action {
  readonly type = ClientsActionTypes.CREATE_CLIENT_SUCCESS;

  constructor(public payload: any) {
    super();
  }
}

export class CreateClientFailed extends Reference implements Action {
  readonly type = ClientsActionTypes.CREATE_CLIENT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class UpdateClient extends Reference implements Action {
  readonly type = ClientsActionTypes.UPDATE_CLIENT;

  constructor(public payload: ClientCreate) {
    super();
  }
}

export class UpdateClientSuccess extends Reference implements Action {
  readonly type = ClientsActionTypes.UPDATE_CLIENT_SUCCESS;

  constructor(public payload: any) {
    super();
  }
}

export class UpdateClientFailed extends Reference implements Action {
  readonly type = ClientsActionTypes.UPDATE_CLIENT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class DeleteClient extends Reference implements Action {
  readonly type = ClientsActionTypes.DELETE_CLIENT;

  constructor(public clientId: string) {
    super();
  }
}

export class DeleteClientSuccess extends Reference implements Action {
  readonly type = ClientsActionTypes.DELETE_CLIENT_SUCCESS;

  constructor(public response: any) {
    super();
  }
}

export class DeleteClientFailed extends Reference implements Action {
  readonly type = ClientsActionTypes.DELETE_CLIENT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadClientsDatatable implements Action {
  readonly type = ClientsActionTypes.LOAD_DATATABLE;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public payload: RequestClientsDatatable,
    public force: boolean = false
  ) {}
}

export class LoadClientsDatatableSuccess implements Action {
  readonly type = ClientsActionTypes.LOAD_DATATABLE_SUCCESS;

  /**
   * @param start start from (from request payload)
   * @param length page size (from request payload)
   */
  constructor(
    public start: number,
    public length: number,
    public payload: Datatable
  ) {}
}

export class LoadClientsDatatableFailed implements Action {
  readonly type = ClientsActionTypes.LOAD_DATATABLE_FAILED;

  constructor(public payload: Error) {}
}

export class UpdateClientThrottle extends Reference implements Action {
  readonly type = ClientsActionTypes.UPDATE_CLIENT_THROTTLE;

  constructor(public payload: ClientRateLimit) {
    super();
  }
}

export class UpdateClientThrottleSuccess extends Reference implements Action {
  readonly type = ClientsActionTypes.UPDATE_CLIENT_THROTTLE_SUCCESS;

  constructor(public payload: any) {
    super();
  }
}

export class UpdateClientThrottleFailed extends Reference implements Action {
  readonly type = ClientsActionTypes.UPDATE_CLIENT_THROTTLE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class BulkUpdateClient extends Reference implements Action {
  readonly type = ClientsActionTypes.BULK_UPDATE_CLIENTS;

  constructor(public payload: any) {
    super();
  }
}

export class BulkUpdateClientSuccess extends Reference implements Action {
  readonly type = ClientsActionTypes.BULK_UPDATE_CLIENTS_SUCCESS;

  constructor(public payload: any) {
    super();
  }
}

export class BulkUpdateClientFailed extends Reference implements Action {
  readonly type = ClientsActionTypes.BULK_UPDATE_CLIENTS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class Reset implements Action {
  readonly type = ClientsActionTypes.RESET;
  constructor() {}
}

export type Actions =
  | LoadClients
  | LoadClientsSucces
  | LoadClientsFailed
  | GetClient
  | GetClientSuccess
  | GetClientFailed
  | CreateClient
  | CreateClientSuccess
  | CreateClientFailed
  | UpdateClient
  | UpdateClientSuccess
  | UpdateClientFailed
  | DeleteClient
  | DeleteClientSuccess
  | DeleteClientFailed
  | LoadClientsDatatable
  | LoadClientsDatatableSuccess
  | LoadClientsDatatableFailed
  | UpdateClientThrottle
  | UpdateClientThrottleSuccess
  | UpdateClientThrottleFailed
  | BulkUpdateClient
  | BulkUpdateClientSuccess
  | BulkUpdateClientFailed
  | Reset;
